import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

import { Link } from "react-router-dom";

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <li className="nav-item dropdown">
      <Link className="nav-link px-sm-3 px-3 me-1" id="dropdownUser" onClick={() => loginWithRedirect()} >
        <div className="text-center">
          <i className="bi bi-person-circle h3"></i><br/>Signin
        </div>
      </Link>  
    </li>
  );
};

export default LoginButton;